import { Injectable } from '@angular/core';
import { CodTipoDetalle } from './pronto-pago-restitucion.service';

/**
 * Estado compartido del flujo "Pronto Pago" entre pasos
 * (Propuesta → Verificación → Resultado).
 */
@Injectable({ providedIn: 'root' })
export class ProntoPagoStateService {

  codTipoDetalleSeleccionado: CodTipoDetalle | null = null;

  reset(): void {
    this.codTipoDetalleSeleccionado = null;
  }
}
